import React, { useState } from 'react';
import { TickLogo } from '../TickLogo';
import usePostData from '@/hooks/usePostData';
import { VITE_NODE_ENV } from '@/utils/getEnv';
import { Spinner } from '../form/Spinner';

interface EnergyResultsModalProps {
  isVisible: boolean;
  onClose: (e: React.MouseEvent) => void;
  onSubmit: () => void;
  uuid: string;
}

const EnergyResultsModal: React.FC<EnergyResultsModalProps> = ({ isVisible, onClose, onSubmit, uuid }) => {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const [sendModels, { loading }] = usePostData();

  if (!isVisible) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    // Close when clicking the overlay (not the content)
    if (e.target === e.currentTarget) onClose(e);
  };

  const handleCloseClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose(e);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleFormSubmit = () => {
    sendModels('email_entered', {
      email: email,
      access_previlege: VITE_NODE_ENV['VITE_USER_PREVILEGE'],
      model: 'address_information',
      uuid: uuid,
    });
    // e.preventDefault();
    setEmailSent(true);
    setTimeout(() => {
      onSubmit();
      setEmail('');
      setEmailSent(false);
    }, 2000);
  };

  return (
    <div
      className="energy-modal-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={handleOverlayClick}
    >
      <div
        className="energy-modal-box"
        style={{
          position: 'relative',
          background: '#fff',
          borderRadius: 14,
          padding: '16px',
          width: 600,
          boxShadow: '0 4px 32px rgba(0,0,0,0.12)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          className="energy-modal-close"
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
          aria-label="Close"
          onClick={handleCloseClick}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
        <div className="energy-modal-checkmark" style={{ display: 'flex', justifyContent: 'start', marginBottom: 20 }}>
          <TickLogo />
        </div>
        <h3 className="energy-modal-title" style={{ fontWeight: 700, fontSize: 20, margin: 0 }}>
          Erfahren Sie mehr!
        </h3>
        <p className="energy-modal-prompt" style={{ marginTop: 2, fontWeight: 400, fontSize: 15, padding: 0 }}>
          Wollen Sie mehr zu Ihren Ergebnissen und den Möglichkeiten Ihres Energiesystems erfahren?
        </p>
        <p
          className="energy-modal-desc"
          style={{ fontSize: 14, marginBottom: 18, marginTop: 18, color: '#000000', padding: 0 }}
        >
          Buchen Sie gerne direkt einen Termin{' '}
          <a 
            href={import.meta.env.VITE_BOOKING_LINK} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#0066cc', textDecoration: 'underline' }}
          >
            hier
          </a>{' '}
          oder hinterlassen Sie uns Ihre E-Mail-Adresse und wir kontaktieren Sie zeitnah.
        </p>

        <div className="flex gap-[10px]">
          <input
            type="email"
            required
            value={email}
            onChange={handleInputChange}
            className="energy-modal-input"
            placeholder="Ihre E-Mail-Adresse"
            style={{
              flex: 1,
              padding: '10px 14px',
              borderRadius: 5,
              border: '1px solid #e1e1e1',
              fontSize: 15,
              background: '#f9f9f9',
            }}
          />
          <button
            type="button"
            onClick={() => handleFormSubmit()}
            className="energy-modal-submit bg-warning"
            style={{
              color: '#232323',
              fontWeight: 600,
              border: 'none',
              borderRadius: 5,
              padding: '0 22px',
              fontSize: 15,
              cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              opacity: loading ? 0.7 : 1,
              transition: 'opacity 0.2s',
            }}
            disabled={loading}
            aria-busy={loading}
          >
            {loading ? <Spinner /> : 'Senden'}
          </button>
        </div>

        <div className={`email-sent-message transition ${emailSent ? 'visible' : 'hidden'}`}>
          <p className="mt-2 text-[#7A818B] text-[14px]">Wir melden uns zeitnah unter: {email}</p>
        </div>
      </div>
    </div>
  );
};

export default EnergyResultsModal;
